(function () {
    'use strict';
    angular.module('finansApp.courseListController', []).controller('courseListController', courseListController);
    
    courseListController.$inject = ['courseService', 'courseSortService', 'courseFilterService', '$timeout', '$cookies', '$location'];


    function courseListController(courseService, courseSortService, courseFilterService, $timeout, $cookies, $location) {
        var vm = this;
        vm.state = courseService.state;
        vm.state.sortOrder = courseSortService.state.sortOrder;
        vm.state.limit = 6;

        vm.loadMore = function() {
            vm.state.limit += 6;
            
                        // Once we have the data, init the images with responsive
            $timeout(function() {
                novicell.responsiveLazyloadImage.onLoad();
            }, 0);
        }

         vm.saveIdInUrl = function(id) {
            var params = $location.search();

            if (id) {
                params.id = id;
            }

            $location.search(params);
         }
        
         vm.goToUrl = function (id, url) {
             vm.saveIdInUrl(id)
             location.href = url;
         }

         vm.showFilter = function(id) {
             if(courseFilterService.state.showFilter == id) {
                 courseFilterService.state.showFilter = 0;
             } else {
                 courseFilterService.state.showFilter = id;
             }
         }

         vm.sortList = function(sortOrder) {
             vm.state.sortOrder = sortOrder;
             courseSortService.state.sortOrder = vm.state.sortOrder;
             
            courseSortService.sortCourses(courseService.state.coursesFiltered).then(function(arr){
                courseService.state.coursesFiltered = arr;
            })
            courseSortService.setUrl();

            // Once we have the data, init the images with responsive
            $timeout(function() {
                novicell.responsiveImages.init();
            }, 0);
         }
        

        function init(data) {
           setViewFromUrl();
           getViewFromCookie();

           if(data.Courses) {
                vm.state.courses = data.Courses;
                vm.state.coursesFiltered = vm.state.courses;
                vm.state.filters = data.Filters;
           }

            // Set the filter in proper order
            courseFilterService.filterCourses(vm.state.courses).then(function (arr) {
                // Set the sort in proper order
                courseSortService.sortCourses(arr).then(function (data) {
                    vm.state.coursesFiltered = data;
                })

                // Once we have the data, init the images with responsive
                $timeout(function () {
                    novicell.responsiveLazyloadImage.onLoad();
                    finansudd.favorites.setFavoritesOnlist();
                }, 0);

                $timeout(scrollToItem, 50);

            })
        } 

        function setViewFromUrl() {
            if(window.location.search.indexOf('layout') > -1 && window.location.search.split('layout=')[1] == "list") {
                vm.state.tableview = $cookies.put('table-view', true);
            } 

        }


        function getViewFromCookie() {
            vm.state.tableview = $cookies.get('table-view') == 'true';
        }

        function scrollToItem() {
            var params = $location.search();

            if(typeof params.id != 'undefined' && params.id != '') {
                finansudd.scrollTo.scrollTarget('#' + params.id)
            }
            
        }

        courseService.getCourses().then(init, init);


    }

})();